<template>
  <div>
    <v-timeline v-for="action in actions_list" :key="`action-${action.id}`" side="end">
      <v-timeline-item v-if="action.status == 'ONGOING'">
        <template v-slot:opposite>
          <div :class="`pt-1 headline font-weight-bold`">Début {{ action.title }}</div>
          <div :class="`pt-1 headline font-weight-bold`">{{ action.start }}</div>
        </template>
        <v-card elevation="4" class="pa-3">
          <v-card-title class="text-h6">{{ action.title }}</v-card-title>
          <v-card-text class="py-2">
            {{ action.study.descriptionGeneral }}
          </v-card-text>
          <v-card-text class="py-2">
            <p class="mb-1">
              <strong>Début :</strong>
              {{ action.start }}
            </p>
            <p class="mb-1">
              <strong>Fin :</strong>
              {{ action.end }}
            </p>
          </v-card-text>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
export default {
  name: "ActionCalendar",
  data() {
    return {
      actions_list: null,
      actionCount: null,
    }
  },
  computed: {
    loading() {
      return this.actionCount === null
    },
  },
  methods: {
    fetchCurrentPage() {
      this.$store
        .dispatch("fetchAction", {})
        .then((response) => {
          this.actions_list = response
          this.actionCount = response.length
        })
        .catch(() => {
          this.$store.dispatch("notifyServerError")
        })
    },
  },
  mounted() {
    this.fetchCurrentPage()
  },
}
</script>
